export default {
  getCourseProcessForm: {
      url: '/blade-workflow/process/getFormByProcessId',
      method: 'get'
  }
};